// app/javascript/controllers/experience_preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  verifyUrl(event) {
    const urlEl = this.element.querySelector('input[name*="[url]"]')
    const urlInput = urlEl.value?.trim()
    if (!urlInput) {
      event.preventDefault();
      return
    }

    const link = event.currentTarget
    const url = new URL(link.href)
    url.searchParams.set("url", urlInput)

    link.href = url.toString()
  }

  updateExperienceUrl(event) {
    const urlEl = this.element.querySelector('input[name*="[url]"]')
    const urlInput = urlEl.value?.trim()
    if (!urlInput) {
      event.preventDefault();
      return
    }

    const formData = new FormData()
    formData.append('url', urlInput)
    const url = new URL(event.currentTarget)

    fetch(url, {
      method: 'PUT',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    })
  }
}
